import React, { createContext, useContext, useState, useCallback } from 'react';
import { getDomains } from './api';

const DomainContext = createContext();

export const useDomain = () => useContext(DomainContext);

export const DomainProvider = ({ children }) => {
  const [domains, setDomains] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState(null); // { id, name, hostname, ... }
  const [loaded, setLoaded] = useState(false);

  const loadDomains = useCallback(async () => {
    try {
      const data = await getDomains();
      setDomains(data);
      setLoaded(true);

      // Restore last selected domain from localStorage
      const savedId = localStorage.getItem('selected_domain_id');
      if (savedId && data.length > 0) {
        const found = data.find(d => d.id === savedId);
        if (found) setSelectedDomain(found);
      }
    } catch (err) {
      console.error('Failed to load domains for context:', err);
    }
  }, []);

  const selectDomain = useCallback((domain) => {
    setSelectedDomain(domain);
    if (domain) {
      localStorage.setItem('selected_domain_id', domain.id);
    } else {
      localStorage.removeItem('selected_domain_id');
    }
  }, []);

  const selectDomainById = useCallback((domainId) => {
    if (!domainId) {
      selectDomain(null);
      return;
    }
    const found = domains.find(d => d.id === domainId);
    if (found) {
      selectDomain(found);
    }
  }, [domains, selectDomain]);

  // Clear on logout
  const clearDomain = useCallback(() => {
    setSelectedDomain(null);
    setDomains([]);
    setLoaded(false);
    localStorage.removeItem('selected_domain_id');
  }, []);

  return (
    <DomainContext.Provider value={{
      domains,
      selectedDomain,
      selectDomain,
      selectDomainById,
      clearDomain,
      loadDomains,
      domainsLoaded: loaded,
    }}>
      {children}
    </DomainContext.Provider>
  );
};
